export default (value) => () => value;
